export interface QandAModel {
    /** Eindeutiger Schlüssel, derselbe wie die id der Kachel auf der Startseite. */
    id: string;
    /** Name im Menü und auf der Kachel der Startseite. */
    title: string;
    /** false: Im Menü nur Platzhalter (und nur bei CurrentSettings.showUnpublishedQandAInMenu), auf der Startseite Ankündigung. Wird beim Go-live einmalig auf true gesetzt. */
    published: boolean;
    /** Attribut der eigenen WIKI-Gruppe dieses Q&A im Backend. */
    groupAttribute: string;
    /** Route des Q&A. Ohne Angabe "qanda". */
    baseRoute?: string;
    /** Schlüssel für den Titel: application::<applicationName>. Ohne Angabe "q&a". Muss beim Go-live gepflegt sein. */
    applicationName?: string;
    /** Bild im Kopfbereich der Q&A-Seite. Ohne Angabe das bisherige Bild aus dem Wiki-Theme. */
    backgroundImage?: string;
    /** CSS-Position des Bilds im Kopfbereich. Ohne Angabe "center bottom". */
    backgroundPosition?: string;
}

export const QANDA_IMAGE_BASE_URL = "https://cdn.imaginarity.com/public/components/showcaseStage/modelStage";

/** Die Reihenfolge hier bestimmt die Reihenfolge im Menü und auf der Startseite. */
export const QANDA_MODELS: QandAModel[] = [
    {
        id: "cayenne-electric", title: "Cayenne Electric", published: true, groupAttribute: "qanda",
        // backgroundImage: `${QANDA_IMAGE_BASE_URL}/cayenne-electric-2800.webp`, backgroundPosition: "center 25%"
    },
    { id: "cayenne", title: "G3 ll", published: false, groupAttribute: "qanda_g3", baseRoute: "qanda_g3", applicationName: "q&a g3", backgroundImage: `${QANDA_IMAGE_BASE_URL}/cayenne-2800.webp`, backgroundPosition: "center 39%" },
    { id: "panamera", title: "E3 lll", published: false, groupAttribute: "qanda_e3", baseRoute: "qanda_e3", applicationName: "q&a e3", backgroundImage: `${QANDA_IMAGE_BASE_URL}/panamera-2800.webp`, backgroundPosition: "center 48%" },
    { id: "718", title: "983", published: false, groupAttribute: "qanda_983", baseRoute: "qanda_983", applicationName: "q&a 983", backgroundImage: `${QANDA_IMAGE_BASE_URL}/718-2800.webp`, backgroundPosition: "center 48%" },
];
